import React from "react";
import { bind } from "decko";

import Liveness from "./Liveness";
import PlaybackRateControls from "./PlaybackRateControls";
import GenericBlackBtn from "./GenericBlackBtn";
import Analytics from "./include/Analytics";

/*
 * Class for handling user controls.
 * Expects full control of video.playbackRate and video.muted
 *
 * Parent may manually pause / play directly on the video element, LiveStream.videoElement.pause()
*/
export default class LiveStreamControls extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            muted: false,
            volume: 0.5,
            volumeSliderOpen: false
        };

        this.hotkeys = {
            "space": this.togglePlay,
            "m": this.toggleMute,
            "n": this.jumpToLive,
            "comma": () => this.jumpOffset(-0.25),
            "period": () => this.jumpOffset( 0.25),
        };
    }

    componentDidMount () {
        this.props.hotkeyHandler.subscribe(this.hotkeys, this);
    }

    componentWillUnmount () {
        this.props.hotkeyHandler.unsubscribe(this.hotkeys, this);
    }

    @bind
    togglePlay () {
        if (this.props.paused) {
            this.props.video.play();
        } else {
            this.props.video.pause();
        }
    }

    @bind
    jumpOffset (seconds) {
        console.log("Jumping offset by", seconds, "seconds");
        let time = this.props.video.currentTime + seconds;
        let endTime = this.props.video.duration - this.props.avrgBufferDuration;
        this.props.video.currentTime = Math.max(0, Math.min(endTime, time));
        Analytics.streamEvent(this.props.stream, "jump", {"duration": seconds});
    }

    @bind
    jumpBackTenSeconds () {
        this.jumpOffset(-10);
    }

    @bind
    jumpToLive () {
        let time = this.props.video.duration - this.props.avrgBufferDuration;
        this.props.video.currentTime = Math.max(0, time);
        this.props.video.play();
        Analytics.streamEvent(this.props.stream, "jumptolive");
    }

    @bind
    toggleMute () {
        const muted = !this.state.muted;
        this.props.video.muted = muted;
        this.setState({muted: muted});
    }

    @bind
    toggleVolumeSlider () {
        this.setState({volumeSliderOpen: !this.state.volumeSliderOpen});
    }

    @bind
    onChangeVolume (ev) {
        const volume = ev.target.value;
        this.props.video.volume = volume;
        this.setState({volume: volume});

        // Currently cannot mute/unmute without keybind. Therefore, on change,
        // we unmute in case it was accidentally toggled on
        if (this.state.muted) this.toggleMute();
    }

    render () {

        const bottomMargin = this.props.useBottomMargin ? "31px" : "7px";

        return (
            <div style={{position: "absolute", width: "100%", height: "100%", left: "0", top: "0"}}>

                <div className="fullheight fullwidth"
                    onClick={() => this.props.hotkeyHandler.hasFocus() ? this.togglePlay() : undefined} />

                {this.props.paused &&
                    <div className="text-outline text-center"
                        style={{
                            pointerEvents: "none",
                            fontSize: "80px",
                            opacity: "0.35",
                            position: "absolute",
                            top: "50%",
                            marginTop: "-45px",
                            width: "100%"
                        }}>
                        <span className="glyphicon glyphicon-pause" />
                    </div>
                }

                <GenericBlackBtn
                    style={{position: "absolute", left: "17px", bottom: bottomMargin}}
                    btnClassName="btn-lg"
                    onClick={this.jumpBackTenSeconds}>
                    <span className="glyphicon glyphicon glyphicon-step-backward" />
                </GenericBlackBtn>

                <GenericBlackBtn
                    style={{position: "absolute", left: "71px", bottom: bottomMargin}}
                    btnClassName="btn-lg"
                    onClick={this.togglePlay}>
                    <span className={"glyphicon glyphicon-" + (
                        this.props.paused ? "play" : "pause"
                    )} />
                </GenericBlackBtn>

                <div className="transparent-black-bg"
                    style={{
                        position: "absolute",
                        bottom: bottomMargin,
                        left: "50%",
                        marginLeft: "-280px",
                        width: "560px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                    }}>
                    <PlaybackRateControls
                        height="66px"
                        startInCatchupMode={this.props.isLive}
                        avrgBufferDuration={this.props.avrgBufferDuration}
                        hotkeyHandler={this.props.hotkeyHandler}
                        paused={this.props.paused}
                        stream={this.props.stream}
                        video={this.props.video} />
                </div>

                <GenericBlackBtn
                    style={{position: "absolute", right: "71px", bottom: bottomMargin}}
                    btnClassName="btn-lg"
                    onClick={this.jumpToLive}>
                    <span className="glyphicon glyphicon glyphicon-fast-forward" />
                </GenericBlackBtn>

                <GenericBlackBtn
                    style={{position: "absolute", right: "17px", bottom: bottomMargin}}
                    btnClassName="btn-lg"
                    onClick={this.toggleVolumeSlider}>
                    {(this.state.muted || this.state.volume < 0.02) ? (
                        <span style={{color: "red"}} className={"glyphicon glyphicon glyphicon-volume-off"} />
                    ) : (
                        <span className={"glyphicon glyphicon glyphicon-volume-up"} />
                    )}
                </GenericBlackBtn>
                {this.state.volumeSliderOpen && (
                    <div
                        className="volume-slider"
                        style={{
                            bottom: this.props.useBottomMargin ? "100px" : "75px"
                        }}>
                        <input type="range"
                               min="0"
                               max="1"
                               step="0.02"
                               value={this.state.volume}
                               onChange={this.onChangeVolume}
                        />
                    </div>
                )}

                {this.props.isLive &&
                    <Liveness style={{
                            position: "absolute",
                            bottom: this.props.useBottomMargin ? "80px" : "55px",
                            left: "17px",
                            width: "106px",
                            height: "20px",
                            borderRadius: "6px",
                            color: "white",
                            border: "1px solid #ccc",
                        }}
                        avrgBufferDuration={this.props.avrgBufferDuration}
                        videoDuration={this.props.videoDuration}
                        videoCurrentTime={this.props.videoCurrentTime}
                    />
                }

            </div>
        );
    }
}

LiveStreamControls.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/js/LiveStreamControls.js